import data from "./StatCardData";

export default {
  ...data,
  props: {
    color: String,
    labelColor: String,
    labelText: String,
    currX: String,
    prevX: String,
    prevMthX: String,
    projectedX: String,
    decimal: String,
  },
  filters: {
    formatAmt: function (value) {
      if (value) {
        return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
  },
  computed: {
    prevCompare() {
      return (this.currX - this.prevX).toFixed(parseInt(this.decimal));
    },
    prevComparePerct() {
      return (((this.currX - this.prevX) / this.prevX) * 100).toFixed(1);
    },
    arrowIcon() {
      if (this.prevCompare < 0) {
        return "mdi-arrow-down";
      } else if (this.prevCompare > 0) {
        return "mdi-arrow-up";
      }
    },
    arrowColor() {
      if (this.prevCompare < 0) {
        return "red";
      } else if (this.prevCompare > 0) {
        return "green";
      }
    },
    projectedArrowColor() {
      if (this.projectedX > this.prevMthX) {
        return "green";
      } else if (this.projectedX < this.prevMthX) {
        return "red";
      }
    },
    projectedCompare() {
      return (this.projectedX - this.prevMthX).toFixed(parseInt(this.decimal));
    },
    projectedComparePerct() {
      return (
        ((this.projectedX - this.prevMthX) / this.prevMthX) *
        100
      ).toFixed(1);
    },
    projectedArrowIcon() {
      if (this.projectedCompare < 0) {
        return "mdi-arrow-down";
      } else if (this.projectedCompare > 0) {
        return "mdi-arrow-up";
      }
    },
    projectedArrowColor() {
      if (this.projectedCompare < 0) {
        return "red";
      } else if (this.projectedCompare > 0) {
        return "green";
      }
    },
    lastMthCompare() {
      return (this.currX - this.prevMthX).toFixed(parseInt(this.decimal));
    },
    lastMthComparePerct() {
      return (((this.currX - this.prevMthX) / this.prevMthX) * 100).toFixed(1);
    },
    lastMthArrowIcon() {
      if (this.lastMthCompare < 0) {
        return "mdi-arrow-down";
      } else if (this.lastMthCompare > 0) {
        return "mdi-arrow-up";
      }
    },
    lastMthArrowColor() {
      if (this.lastMthCompare < 0) {
        return "red";
      } else if (this.lastMthCompare > 0) {
        return "green";
      }
    },
  },
  methods: {},
};
